import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from 'react';
import Transition from 'react-transition-group/Transition';
import ScrollListener from '../../events/ScrollListener';
import { reDraw } from '../../helpers/common';
import { scrollToTop } from '../../helpers/ScrollUtils';
const ScrollToTopButton = () => {
    const [showScrollToTop, changeShowScrollToTop] = useState(false);
    useEffect(() => {
        const no = ScrollListener.setListener((scrollTop) => {
            const { clientHeight } = document.documentElement;
            changeShowScrollToTop(scrollTop > clientHeight / 2);
        });
        return () => {
            ScrollListener.deleteListener(no);
        };
    }, [changeShowScrollToTop]);
    return (_jsx(Transition, Object.assign({ in: showScrollToTop, mountOnEnter: true, onEnter: reDraw, onExit: reDraw, timeout: 300, unmountOnExit: true }, { children: (state) => (_jsx("div", Object.assign({ className: 'scroll-to-top' }, { children: _jsx("button", Object.assign({ className: `scroll_button animated-opacity ${state}`, onClick: scrollToTop, type: 'button' }, { children: _jsx("i", Object.assign({ className: 'material-icons' }, { children: "arrow_upward" })) })) }))) })));
};
export default ScrollToTopButton;
